export const REFUEL_MESSAGES = {
  PREVIEW_DESCRIPTION:
    'A data indicada corresponde à <strong>previsão</strong> do seu abastecimento. <strong>Caso haja necessidade de alteração, a Ultragaz realizará até as 16h do dia anterior.</strong> Recomendamos que <strong><u>confirme a programação próximo à data.</u></strong>',
  SELECT_BASE:
    'Selecione o local de abastecimento para visualizar a previsão do seu próximo reabastecimento.',
  UNABLE_TO_CALCULATE:
    'Não foi possível calcular a previsão do próximo abastecimento. Por favor, tente novamente mais tarde.',
};
